/**
 * Isotipo de PokeTrack.
 *
 * Es una IMAGEN (la pokebola-grafico entregada como arte final), ya no el SVG
 * dibujado a mano que hubo antes: el arte definitivo lo puso el dueño del
 * proyecto en client/public y este componente solo lo sirve.
 *
 * El original mide 1024 px y pesa 1.5 MB; lo que se sirve es /logo.png, una
 * version recortada al contenido, centrada en lienzo cuadrado (el original no
 * era cuadrado: la linea amarilla sobresale del disco, y un resize directo lo
 * deformaba) y reducida a 256 px, que cubre cualquier tamaño de cabecera en
 * pantallas retina. El favicon sale del mismo arte a 64 px.
 */
export default function Logo({ size = 28, withWordmark = false, className = '' }) {
  return (
    <span className={`logo ${className}`.trim()}>
      <img
        src="/logo.png"
        width={size}
        height={size}
        alt=""
        aria-hidden="true"
        className="logo__mark"
        /* La cabecera lo pinta en cada vista: que no parpadee ni espere. */
        loading="eager"
        decoding="async"
      />
      {withWordmark && (
        <span className="logo__word">
          Poke<span className="logo__word--accent">Track</span>
        </span>
      )}
    </span>
  );
}
